
<template>
  <div class="container">
    <div class="handle-box">
      <el-select v-model="query.is_online" clearable placeholder="状态" class="handle-input mr10">
        <el-option
            v-for="item in onlineOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
        >
        </el-option>
      </el-select>
      <el-input v-model="query.code" placeholder="设备编码" class="handle-input mr10 w150"></el-input>
      <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
    </div>
    <el-table
        :data="tableData"
        border
        class="table"
        ref="multipleTable"
        header-cell-class-name="table-header"
    >
      <el-table-column prop="id" label="ID" width="170" align="center"></el-table-column>
      <el-table-column prop="code" label="设备编码" align="center"></el-table-column>
      <el-table-column label="在线状态" width="100" align="center">
        <template #default="scope">
              {{ scope.row.is_online ? "在线" : "离线" }}
        </template>
      </el-table-column>
      <el-table-column prop="msg" label="提示" align="center"></el-table-column>
      <el-table-column prop="c_at" :formatter="dateFormatHMS" label="发生时间" header-align="center" align="center"></el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handlePageChange"
          :current-page="query.page"
          :page-sizes="[10,20, 50, 100, 200]"
          :page-size="10"
          layout="total,sizes, prev, pager, next"
          :total="pageTotal">
      </el-pagination>
    </div>
  </div>
</template>
<script>
import {getConnLogs} from '@/api/logs'
import moment from "moment/moment";
export default {
  data(){
    return{
      query:{
        is_online:null,
        code:'',
        page:1,
        page_size:10
      },
      onlineOptions:[
        {
          value: false,
          label: '离线'
        },
        {
          value:true,
          label:'在线'
        }
      ],
      tableData:[],
      pageTotal:0
    }
  },
  created() {
    this.getData()
  },
  methods:{
    dateFormatHMS: function (row, column) {
      const date = row[column.property];
      if (date === undefined || date === 0) {
        return "";
      }
      return moment(parseInt(date + "000")).format("YYYY-MM-DD HH:mm:ss")
    },
    getData(){
      getConnLogs(this.query).then(res=>{
        this.tableData = res.data
        if(res.count){
          this.pageTotal = res.count
        }
      })
    },
    handleSearch(){
      this.query.page = 1
      this.getData()
    },
    // 每页大小变化
    handleSizeChange(val){
      this.query.page_size = val
      this.getData()
    },

    // 分页导航
    handlePageChange(val) {
      this.query.page = val
      this.getData()
    },
  }
}
</script>

<style scoped>
.el-select{
  margin-right: 10px;
  width: 100px;
}
.el-input{
  width: 200px;
  margin-right: 10px;
}
.handle-box {
  margin-bottom: 20px;
}
</style>